export const translations = {
  en: {
    // Header
    header: {
      termVsWhole: "Term vs Whole Life",
      onlineVsAgent: "Online vs Agent",
      licensedInCalifornia: "Licensed in California",
      licenseNumber: "CA License #6013543",
      getMyPrice: "Get My Price"
    },
    
    // Homepage
    homepage: {
      heroTitle: "Confused by Life Insurance",
      heroTitleHighlight: "Options?",
      heroSubtitle: "Chat with Our AI Agent, or Watch our Video to understand your needs.",
      watchVideo: "Watch Video",
      chatWithAI: "Chat with Our AI Agent",
      poweredBy: "Powered by",
      asFeaturedIn: "As featured in",
      expertGuidanceTitle: "Get Expert Insurance Guidance",
      expertGuidanceSubtitle: "Our AI-powered virtual agent is here to help you navigate life insurance options. Ask questions, get definitions, share your goals, and receive personalized recommendations.",
      virtualAgentTitle: "Insurance Virtual Agent",
      virtualAgentSubtitle: "Ask me anything about life insurance!",
      whatYouCanAsk: "What You Can Ask:",
      askItems: [
        "Get life insurance product recommendations",
        "Ask questions about coverage options", 
        "Define insurance jargon and terminology",
        "Share your goals for personalized advice"
      ],
      perfectIfYoure: "Perfect If You're:",
      perfectItems: [
        "Unsure which insurance product to buy",
        "New to life insurance",
        "Comparing term vs whole life insurance",
        "Looking for expert guidance"
      ],
      readyGetPrice: "Ready? Get My Price",
      whyChooseEthosTitle: "Why Choose Ethos Life Insurance?",
      whyChooseEthosSubtitle: "Experience the future of life insurance with our partner Ethos - simple, fast, and designed for modern families.",
      benefits: [
        {
          title: "No Medical Exam Required",
          description: "Get coverage without the hassle of medical exams or doctor visits"
        },
        {
          title: "Apply from Home", 
          description: "Complete your entire application online from the comfort of your home"
        },
        {
          title: "Quick Approval",
          description: "Get approved in minutes, not weeks, with our streamlined process"
        },
        {
          title: "Competitive Rates",
          description: "Access affordable life insurance rates tailored to your needs"
        }
      ],
      trustedBy: "Powered by Ethos - trusted by thousands of families nationwide",
      aboutTitle: "About Burbank Insurance Services",
      aboutText1: "At Burbank Insurance Services, we're committed to making life insurance accessible and understandable for California families. Through our partnership with Ethos, we bring you cutting-edge technology that simplifies the insurance buying process.",
      aboutText2: "Our mission is to protect California families by providing transparent, affordable, and convenient life insurance solutions. No more complicated paperwork, lengthy medical exams, or confusing jargon - just straightforward protection for what matters most.",
      whyWorkWithUs: "Why Work With Us?",
      workWithUsItems: [
        {
          title: "Licensed California Professionals",
          description: "Fully licensed insurance professionals you can trust"
        },
        {
          title: "Technology-Driven", 
          description: "Leveraging AI and modern tech for better service"
        },
        {
          title: "Customer-Focused",
          description: "Your needs and goals are our top priority"
        }
      ],
      proudlyServing: "Proudly serving California families",
      finalCTATitle: "Ready to Protect Your California Family?",
      finalCTASubtitle: "Don't wait - life happens when you least expect it. Get your personalized quote today and secure your family's financial future in just minutes.",
      getMyPriceNow: "Get My Price Now",
      watchVideoGuide: "Watch Video Guide"
    },

    // Term vs Whole Life
    termVsWhole: {
      heroTitle: "Term vs Whole Life Insurance",
      heroSubtitle: "Which Is Right for You?",
      heroDescription: "Understanding the key differences between term and whole life insurance will help you make the best decision for your family's financial protection.",
      getMyPrice: "Get My Price",
      sideByySideComparison: "Side-by-Side Comparison",
      termLifeInsurance: "Term Life Insurance",
      termSubtitle: "Temporary Protection, Maximum Coverage",
      wholeLifeInsurance: "Whole Life Insurance", 
      wholeSubtitle: "Permanent Protection + Investment",
      termBenefits: [
        "Lower monthly premiums",
        "Temporary coverage (10-30 years)",
        "High death benefit amounts",
        "Simple and straightforward"
      ],
      wholeBenefits: [
        "Builds cash value over time",
        "Permanent lifetime coverage", 
        "Can borrow against cash value",
        "Fixed premiums for life"
      ],
      typicalCosts: "Typical Costs:",
      getTermQuote: "Get Term Life Quote",
      getWholeQuote: "Get Whole Life Quote",
      whoShouldChooseWhat: "Who Should Choose What?",
      termPerfectFor: "Term Life Is Perfect For:",
      wholePerfectFor: "Whole Life Is Perfect For:",
      termProfiles: [
        {
          title: "Young Families",
          description: "Parents with young children who need maximum coverage at the lowest cost during their most financially vulnerable years.",
          age: "Ages 25-40",
          scenario: "Protecting dependents until they're financially independent"
        },
        {
          title: "Working Professionals", 
          description: "Career-focused individuals with mortgages and debts who need substantial coverage during their earning years.",
          age: "Ages 30-50",
          scenario: "Covering mortgage and income replacement needs"
        },
        {
          title: "Budget-Conscious Buyers",
          description: "People who want significant life insurance protection but have limited monthly budgets for premiums.",
          age: "Any age", 
          scenario: "Maximum coverage with minimal premium outlay"
        }
      ],
      wholeProfiles: [
        {
          title: "Wealth Builders",
          description: "High-income earners who want life insurance that doubles as an investment vehicle with tax advantages.",
          age: "Ages 35+",
          scenario: "Building tax-deferred wealth while maintaining coverage"
        },
        {
          title: "Estate Planners",
          description: "Individuals planning to leave a guaranteed inheritance or cover estate taxes for their beneficiaries.", 
          age: "Ages 45+",
          scenario: "Permanent wealth transfer and estate planning"
        },
        {
          title: "Lifetime Protection Seekers",
          description: "People who want guaranteed coverage that will never expire, regardless of health changes.",
          age: "Any age",
          scenario: "Permanent protection with guaranteed premiums"
        }
      ],
      quickDecisionHelper: "Quick Decision Helper",
      answerQuestions: "Answer these questions to guide your choice:",
      chooseTermIf: "Choose Term Life If:",
      termChoiceReasons: [
        "You need maximum coverage for less money",
        "You have temporary financial obligations", 
        "You plan to be self-insured later",
        "You want to invest the difference elsewhere"
      ],
      chooseWholeIf: "Choose Whole Life If:",
      wholeChoiceReasons: [
        "You want permanent, guaranteed coverage",
        "You need tax-advantaged savings",
        "You want to leave a guaranteed inheritance", 
        "You have maxed out other retirement accounts"
      ],
      readyToDecide: "Ready to Make Your Decision?",
      noAnalysisParalysis: "Don't let analysis paralysis stop you from protecting your family. Get personalized quotes for both term and whole life insurance and see the real numbers for your situation.",
      getPersonalizedQuote: "Get My Personalized Quote",
      compareBothOptions: "Compare both options with real prices in under 2 minutes"
    },

    // Online vs Agent
    onlineVsAgent: {
      heroTitle: "Online vs Agent",
      heroSubtitle: "Life Insurance",
      heroDescription: "Discover which approach is right for you - the convenience of online insurance or the personal touch of a traditional agent.",
      getOnlineQuote: "Get My Online Quote",
      sideByySideComparison: "Side-by-Side Comparison",
      onlineInsurance: "Online Insurance",
      onlineSubtitle: "Fast, Convenient, Cost-Effective",
      agentInsurance: "Agent Insurance",
      agentSubtitle: "Personal Service, Expert Guidance",
      onlineBenefits: [
        {
          title: "Speed & Convenience",
          description: "Apply 24/7 from anywhere in 10-15 minutes vs scheduling appointments and waiting weeks"
        },
        {
          title: "Lower Costs", 
          description: "No agent commissions mean lower premiums and transparent pricing with no hidden fees"
        },
        {
          title: "No Medical Exam",
          description: "Skip the inconvenient medical appointments with our advanced health questionnaire"
        },
        {
          title: "Privacy & Control",
          description: "Complete the process privately without pressure tactics or sales presentations"
        }
      ],
      agentBenefits: [
        {
          title: "Personal Guidance",
          description: "Face-to-face consultation with experienced professionals who know your situation"
        },
        {
          title: "Complex Cases",
          description: "Handle high-risk health conditions, large policies, and complicated financial situations"
        },
        {
          title: "Ongoing Support", 
          description: "Dedicated relationship manager for claims, policy changes, and life events"
        },
        {
          title: "Risk Assessment",
          description: "Expert evaluation for unique occupations, hobbies, or medical conditions"
        }
      ],
      getOnlineQuoteBtn: "Get Online Quote",
      contactAgent: "Contact Agent",
      featureComparison: "Feature Comparison",
      onlinePerfectFor: "Online Insurance Is Perfect For",
      whenNeedAgent: "When You Need an Agent",
      seeEstimatedPremium: "See Your Online Premium Estimate",
      adjustControls: "Adjust the controls to see how different factors affect your monthly premium",
      coverageAmount: "Coverage Amount",
      age: "Age",
      termLength: "Term Length",
      smokingStatus: "Smoking Status",
      nonSmoker: "Non-Smoker",
      smoker: "Smoker",
      smokingWarning: "⚠️ Smoking significantly increases life insurance premiums",
      healthCondition: "Health Condition",
      healthOptions: [
        {
          label: "Poor Health",
          description: "Chronic conditions, multiple medications, recent health issues",
          examples: ["Diabetes", "Heart disease", "High blood pressure", "Recent surgery"]
        },
        {
          label: "Average Health", 
          description: "Generally healthy with minor issues or family history concerns",
          examples: ["Occasional medication", "Minor family history", "Slightly overweight", "Routine checkups"]
        },
        {
          label: "Excellent Health",
          description: "Outstanding health, active lifestyle, no medications",
          examples: ["Regular exercise", "No medications", "Healthy weight", "No family history"]
        }
      ],
      perMonth: "per month",
      perYear: "per year",
      healthSavings: "Health Savings",
      youSave: "You save",
      compared: "compared to poor health",
      thatsPerYear: "That's",
      inSavings: "in savings!",
      quoteDetails: "Quote Details:",
      smoking: "Smoking:",
      health: "Health:",
      coverage: "Coverage:",
      term: "Term:",
      getExactQuote: "Get Exact Quote",
      estimateDisclaimer: "*Estimate based on industry averages. Actual rates may vary based on health, lifestyle, and other underwriting factors.",
      trustedByPublications: "Trusted by Leading Publications",
      readyToChoose: "Ready to Choose Your Path?",
      mostPeopleQualify: "Most people qualify for fast, convenient online insurance. But if you have complex needs or health issues, our experienced agents are here to help find the right solution.",
      tryOnlineFirst: "Try Online First",
      contactAgentBtn: "Contact Agent",
      onlineApplication: "✓ Online: 10-minute application, instant approval",
      agentConsultation: "✓ Agent: Personal consultation, complex cases welcome",
      importantNote: "⚠️ Important Note",
      complexCasesNote: "If you have serious health conditions, high-risk occupations, or need coverage over $2M, online applications may not be available. An experienced agent can navigate complex underwriting and find solutions when online options aren't suitable.",
      contactOurAgents: "Contact Our Agents"
    },

    // City Insurance Page
    cityInsurance: {
      pageNotFound: "Page Not Found",
      requestedNotFound: "The requested city or insurance type was not found.",
      whyChooseUs: "Why Choose Us for",
      uniqueNeeds: "We understand the unique needs of",
      residents: "residents and provide personalized life insurance solutions for",
      families: "families.",
      localBenefits: [
        "Licensed in California (CA License #6013543)",
        "No medical exam required for most applicants", 
        "Online quotes available 24/7",
        "Local California insurance expertise"
      ],
      coverageFor: "Coverage for",
      livingIn: "Living in",
      youNeed: "you need life insurance protection that fits your California lifestyle. Our",
      policiesDesigned: "policies are designed specifically for California residents, with competitive rates and comprehensive coverage options.",
      longtime: "Whether you're a longtime",
      resident: "resident or new to",
      protecting: "protecting your family's financial future is essential. Our online application process makes it easy to get coverage without the hassle of traditional insurance shopping.",
      proudlyServing: "Proudly serving",
      andAllOf: "and all of",
      getYourQuote: "Get Your",
      quoteTodayBtn: "Quote Today",
      applicationTime: "Application Time:",
      medicalExam: "Medical Exam:",
      approvalTime: "Approval Time:",
      coverageArea: "Coverage Area:",
      minutes: "10-15 minutes",
      usuallyNotRequired: "Usually not required", 
      oftenInstant: "Often instant",
      getQuoteBtn: "Get My",
      quote: "Quote",
      licensedProfessionals: "Licensed California insurance professionals • CA License #6013543",
      whatResidentsSay: "What",
      residentsSay: "Residents Say",
      coverage: "Coverage:",
      premium: "Premium:",
      readyToProtect: "Ready to Protect Your",
      family: "Family?",
      dontWait: "Don't wait to secure your family's financial future. Get your personalized",
      forCity: "for",
      today: "today.",
      getQuoteNow: "Get My",
      quoteNow: "Quote Now",
      licensedServing: "Licensed in California • Serving",
      and: "and"
    },

    // Footer
    footer: {
      coverageAcrossCA: "Life Insurance Coverage Across California",
      coverageSubtitle: "Burbank Insurance Services proudly serves residents throughout California with comprehensive life insurance solutions. Find coverage options in your city.",
      popularProducts: "Popular Life Insurance Products",
      availableThroughout: "Available throughout California",
      additionalServices: "Additional Life Insurance Services",
      availableAllCities: "Available in all California cities",
      californiaLifeInsurance: "California Life Insurance Coverage",
      footerText1: "Burbank Insurance Services is proud to serve residents throughout the state of California with comprehensive life insurance solutions. Whether you're in Los Angeles, San Francisco, San Diego, or any other California city, our licensed insurance professionals are here to help you find the right coverage for your family's needs.",
      footerText2: "We specialize in term life insurance, whole life insurance, and no-exam life insurance policies for California residents. Our online application process makes it easy to get quotes and apply for coverage from anywhere in the Golden State.",
      serviceAreas: "Service Areas:",
      serviceAreasText: "We serve all major California cities including Los Angeles County, Orange County, San Francisco Bay Area, San Diego County, Sacramento, Fresno, Riverside County, San Bernardino County, and all surrounding areas throughout California.",
      getCaliforniaQuote: "Get Your California Life Insurance Quote",
      licensedInCA: "Licensed in California • CA License #6013543",
      learnMore: "Learn More",
      contactUs: "Contact Us",
      servingCAOnly: "Serving California residents only",
      readyToStart: "Ready to Get Started?",
      getPersonalizedQuote: "Get your personalized quote in minutes.",
      getMyPriceNow: "Get My Price Now",
      allRightsReserved: "All rights reserved. CA License #6013543",
      protectingFamilies: "Protecting California families with modern life insurance solutions.",
      termVsWhole: "Term vs Whole Life",
      onlineVsAgent: "Online vs Agent",
      lifeInsurance: "Life Insurance",
      insuranceConsultation: "Insurance Consultation",
      cities: "cities"
    },

    // Common/Shared
    common: {
      getQuote: "Get Quote",
      contactAgent: "Contact Agent", 
      learnMore: "Learn More",
      readMore: "Read More",
      getStarted: "Get Started",
      close: "Close",
      next: "Next",
      previous: "Previous",
      loading: "Loading...",
      error: "Error",
      success: "Success"
    }
  },
  
  es: {
    // Header
    header: {
      termVsWhole: "Término vs Vida Entera",
      onlineVsAgent: "En Línea vs Agente", 
      licensedInCalifornia: "Licenciado en California",
      licenseNumber: "Licencia CA #6013543",
      getMyPrice: "Obtener Mi Precio"
    },

    // Homepage  
    homepage: {
      heroTitle: "¿Confundido por las Opciones de",
      heroTitleHighlight: "Seguro de Vida?",
      heroSubtitle: "Chatea con Nuestro Agente de IA, o Mira nuestro Video para entender tus necesidades.",
      watchVideo: "Ver Video",
      chatWithAI: "Chatear con Nuestro Agente de IA",
      poweredBy: "Impulsado por",
      asFeaturedIn: "Como se presenta en",
      expertGuidanceTitle: "Obtén Orientación Experta en Seguros",
      expertGuidanceSubtitle: "Nuestro agente virtual impulsado por IA está aquí para ayudarte a navegar las opciones de seguro de vida. Haz preguntas, obtén definiciones, comparte tus objetivos y recibe recomendaciones personalizadas.",
      virtualAgentTitle: "Agente Virtual de Seguros",
      virtualAgentSubtitle: "¡Pregúntame cualquier cosa sobre seguro de vida!",
      whatYouCanAsk: "Lo Que Puedes Preguntar:",
      askItems: [
        "Obtener recomendaciones de productos de seguro de vida",
        "Hacer preguntas sobre opciones de cobertura",
        "Definir jerga y terminología de seguros", 
        "Compartir tus objetivos para consejos personalizados"
      ],
      perfectIfYoure: "Perfecto Si Estás:",
      perfectItems: [
        "Inseguro sobre qué producto de seguro comprar",
        "Nuevo en seguros de vida",
        "Comparando seguro de término vs vida entera",
        "Buscando orientación experta"
      ],
      readyGetPrice: "¿Listo? Obtener Mi Precio",
      whyChooseEthosTitle: "¿Por Qué Elegir el Seguro de Vida Ethos?",
      whyChooseEthosSubtitle: "Experimenta el futuro del seguro de vida con nuestro socio Ethos - simple, rápido y diseñado para familias modernas.",
      benefits: [
        {
          title: "No Se Requiere Examen Médico",
          description: "Obtén cobertura sin la molestia de exámenes médicos o visitas al doctor"
        },
        {
          title: "Aplica Desde Casa",
          description: "Completa toda tu aplicación en línea desde la comodidad de tu hogar"
        },
        {
          title: "Aprobación Rápida", 
          description: "Obtén aprobación en minutos, no semanas, con nuestro proceso simplificado"
        },
        {
          title: "Tarifas Competitivas",
          description: "Accede a tarifas de seguro de vida asequibles adaptadas a tus necesidades"
        }
      ],
      trustedBy: "Impulsado por Ethos - confiado por miles de familias a nivel nacional",
      aboutTitle: "Acerca de Burbank Insurance Services",
      aboutText1: "En Burbank Insurance Services, estamos comprometidos a hacer que el seguro de vida sea accesible y comprensible para las familias de California. A través de nuestra asociación con Ethos, te traemos tecnología de vanguardia que simplifica el proceso de compra de seguros.",
      aboutText2: "Nuestra misión es proteger a las familias de California proporcionando soluciones de seguro de vida transparentes, asequibles y convenientes. No más papeleo complicado, exámenes médicos largos o jerga confusa - solo protección directa para lo que más importa.",
      whyWorkWithUs: "¿Por Qué Trabajar Con Nosotros?",
      workWithUsItems: [
        {
          title: "Profesionales Licenciados de California",
          description: "Profesionales de seguros completamente licenciados en quienes puedes confiar"
        },
        {
          title: "Impulsado por Tecnología",
          description: "Aprovechando IA y tecnología moderna para mejor servicio"
        },
        {
          title: "Enfocado en el Cliente",
          description: "Tus necesidades y objetivos son nuestra máxima prioridad"
        }
      ],
      proudlyServing: "Sirviendo orgullosamente a familias de California",
      finalCTATitle: "¿Listo para Proteger a Tu Familia de California?", 
      finalCTASubtitle: "No esperes - la vida sucede cuando menos lo esperas. Obtén tu cotización personalizada hoy y asegura el futuro financiero de tu familia en solo minutos.",
      getMyPriceNow: "Obtener Mi Precio Ahora",
      watchVideoGuide: "Ver Guía en Video"
    },

    // Term vs Whole Life
    termVsWhole: {
      heroTitle: "Seguro de Vida a Término vs Vida Entera",
      heroSubtitle: "¿Cuál es Correcto para Ti?",
      heroDescription: "Entender las diferencias clave entre el seguro de vida a término y vida entera te ayudará a tomar la mejor decisión para la protección financiera de tu familia.",
      getMyPrice: "Obtener Mi Precio",
      sideByySideComparison: "Comparación Lado a Lado",
      termLifeInsurance: "Seguro de Vida a Término",
      termSubtitle: "Protección Temporal, Cobertura Máxima",
      wholeLifeInsurance: "Seguro de Vida Entera",
      wholeSubtitle: "Protección Permanente + Inversión",
      termBenefits: [
        "Primas mensuales más bajas",
        "Cobertura temporal (10-30 años)",
        "Montos altos de beneficio por muerte",
        "Simple y directo"
      ],
      wholeBenefits: [
        "Construye valor en efectivo con el tiempo",
        "Cobertura permanente de por vida",
        "Puedes pedir prestado contra el valor en efectivo",
        "Primas fijas de por vida"
      ],
      typicalCosts: "Costos Típicos:",
      getTermQuote: "Obtener Cotización a Término",
      getWholeQuote: "Obtener Cotización de Vida Entera",
      whoShouldChooseWhat: "¿Quién Debe Elegir Qué?",
      termPerfectFor: "El Seguro a Término es Perfecto Para:",
      wholePerfectFor: "El Seguro de Vida Entera es Perfecto Para:",
      termProfiles: [
        {
          title: "Familias Jóvenes",
          description: "Padres con niños pequeños que necesitan cobertura máxima al menor costo durante sus años más vulnerables financieramente.",
          age: "Edades 25-40",
          scenario: "Protegiendo dependientes hasta que sean financieramente independientes"
        },
        {
          title: "Profesionales Trabajadores",
          description: "Individuos enfocados en su carrera con hipotecas y deudas que necesitan cobertura sustancial durante sus años de ingresos.",
          age: "Edades 30-50",
          scenario: "Cubriendo hipoteca y necesidades de reemplazo de ingresos"
        },
        {
          title: "Compradores Conscientes del Presupuesto",
          description: "Personas que quieren protección significativa de seguro de vida pero tienen presupuestos mensuales limitados para primas.",
          age: "Cualquier edad",
          scenario: "Cobertura máxima con desembolso mínimo de prima"
        }
      ],
      wholeProfiles: [
        {
          title: "Constructores de Riqueza",
          description: "Personas de altos ingresos que quieren seguro de vida que funcione como vehículo de inversión con ventajas fiscales.",
          age: "Edades 35+",
          scenario: "Construyendo riqueza con impuestos diferidos mientras mantiene cobertura"
        },
        {
          title: "Planificadores de Patrimonio",
          description: "Individuos planeando dejar una herencia garantizada o cubrir impuestos de patrimonio para sus beneficiarios.",
          age: "Edades 45+",
          scenario: "Transferencia permanente de riqueza y planificación de patrimonio"
        },
        {
          title: "Buscadores de Protección de por Vida",
          description: "Personas que quieren cobertura garantizada que nunca expire, sin importar los cambios de salud.",
          age: "Cualquier edad",
          scenario: "Protección permanente con primas garantizadas"
        }
      ],
      quickDecisionHelper: "Ayuda Rápida para Decidir",
      answerQuestions: "Responde estas preguntas para guiar tu elección:",
      chooseTermIf: "Elige Seguro a Término Si:",
      termChoiceReasons: [
        "Necesitas cobertura máxima por menos dinero",
        "Tienes obligaciones financieras temporales",
        "Planeas ser auto-asegurado más tarde",
        "Quieres invertir la diferencia en otro lugar"
      ],
      chooseWholeIf: "Elige Seguro de Vida Entera Si:",
      wholeChoiceReasons: [
        "Quieres cobertura permanente y garantizada",
        "Necesitas ahorros con ventajas fiscales",
        "Quieres dejar una herencia garantizada",
        "Has maximizado otras cuentas de jubilación"
      ],
      readyToDecide: "¿Listo para Tomar Tu Decisión?",
      noAnalysisParalysis: "No dejes que la parálisis del análisis te impida proteger a tu familia. Obtén cotizaciones personalizadas para seguro a término y vida entera y ve los números reales para tu situación.",
      getPersonalizedQuote: "Obtener Mi Cotización Personalizada",
      compareBothOptions: "Compara ambas opciones con precios reales en menos de 2 minutos"
    },

    // Online vs Agent
    onlineVsAgent: {
      heroTitle: "En Línea vs Agente",
      heroSubtitle: "Seguro de Vida",
      heroDescription: "Descubre qué enfoque es correcto para ti - la conveniencia del seguro en línea o el toque personal de un agente tradicional.",
      getOnlineQuote: "Obtener Mi Cotización En Línea",
      sideByySideComparison: "Comparación Lado a Lado",
      onlineInsurance: "Seguro En Línea",
      onlineSubtitle: "Rápido, Conveniente, Rentable",
      agentInsurance: "Seguro con Agente",
      agentSubtitle: "Servicio Personal, Orientación Experta",
      onlineBenefits: [
        {
          title: "Velocidad y Conveniencia",
          description: "Aplica 24/7 desde cualquier lugar en 10-15 minutos vs programar citas y esperar semanas"
        },
        {
          title: "Costos Más Bajos",
          description: "Sin comisiones de agente significa primas más bajas y precios transparentes sin tarifas ocultas"
        },
        {
          title: "Sin Examen Médico",
          description: "Evita las citas médicas inconvenientes con nuestro cuestionario de salud avanzado"
        },
        {
          title: "Privacidad y Control",
          description: "Completa el proceso en privado sin tácticas de presión o presentaciones de ventas"
        }
      ],
      agentBenefits: [
        {
          title: "Orientación Personal",
          description: "Consulta cara a cara con profesionales experimentados que conocen tu situación"
        },
        {
          title: "Casos Complejos",
          description: "Maneja condiciones de salud de alto riesgo, pólizas grandes y situaciones financieras complicadas"
        },
        {
          title: "Soporte Continuo",
          description: "Gerente de relaciones dedicado para reclamos, cambios de póliza y eventos de vida"
        },
        {
          title: "Evaluación de Riesgos",
          description: "Evaluación experta para ocupaciones, pasatiempos o condiciones médicas únicas"
        }
      ],
      getOnlineQuoteBtn: "Obtener Cotización En Línea",
      contactAgent: "Contactar Agente",
      featureComparison: "Comparación de Características",
      onlinePerfectFor: "El Seguro En Línea es Perfecto Para",
      whenNeedAgent: "Cuándo Necesitas un Agente",
      seeEstimatedPremium: "Ve Tu Estimación de Prima En Línea",
      adjustControls: "Ajusta los controles para ver cómo diferentes factores afectan tu prima mensual",
      coverageAmount: "Monto de Cobertura",
      age: "Edad",
      termLength: "Duración del Término",
      smokingStatus: "Estado de Fumador",
      nonSmoker: "No Fumador",
      smoker: "Fumador",
      smokingWarning: "⚠️ Fumar aumenta significativamente las primas de seguro de vida",
      healthCondition: "Condición de Salud",
      healthOptions: [
        {
          label: "Salud Pobre",
          description: "Condiciones crónicas, múltiples medicamentos, problemas de salud recientes",
          examples: ["Diabetes", "Enfermedad cardíaca", "Presión arterial alta", "Cirugía reciente"]
        },
        {
          label: "Salud Promedio",
          description: "Generalmente saludable con problemas menores o preocupaciones de historial familiar",
          examples: ["Medicamento ocasional", "Historial familiar menor", "Ligeramente con sobrepeso", "Chequeos de rutina"]
        },
        {
          label: "Salud Excelente",
          description: "Salud sobresaliente, estilo de vida activo, sin medicamentos",
          examples: ["Ejercicio regular", "Sin medicamentos", "Peso saludable", "Sin historial familiar"]
        }
      ],
      perMonth: "por mes",
      perYear: "por año",
      healthSavings: "Ahorros de Salud",
      youSave: "Ahorras",
      compared: "comparado con salud pobre",
      thatsPerYear: "¡Eso son",
      inSavings: "en ahorros!",
      quoteDetails: "Detalles de Cotización:",
      smoking: "Fumador:",
      health: "Salud:",
      coverage: "Cobertura:",
      term: "Término:",
      getExactQuote: "Obtener Cotización Exacta",
      estimateDisclaimer: "*Estimación basada en promedios de la industria. Las tarifas reales pueden variar según la salud, estilo de vida y otros factores de suscripción.",
      trustedByPublications: "Confiado por Publicaciones Líderes",
      readyToChoose: "¿Listo para Elegir Tu Camino?",
      mostPeopleQualify: "La mayoría de las personas califican para seguro en línea rápido y conveniente. Pero si tienes necesidades complejas o problemas de salud, nuestros agentes experimentados están aquí para ayudar a encontrar la solución correcta.",
      tryOnlineFirst: "Prueba En Línea Primero",
      contactAgentBtn: "Contactar Agente",
      onlineApplication: "✓ En Línea: Aplicación de 10 minutos, aprobación instantánea",
      agentConsultation: "✓ Agente: Consulta personal, casos complejos bienvenidos",
      importantNote: "⚠️ Nota Importante",
      complexCasesNote: "Si tienes condiciones de salud serias, ocupaciones de alto riesgo, o necesitas cobertura de más de $2M, las aplicaciones en línea pueden no estar disponibles. Un agente experimentado puede navegar la suscripción compleja y encontrar soluciones cuando las opciones en línea no son adecuadas.",
      contactOurAgents: "Contactar Nuestros Agentes"
    },

    // City Insurance Page
    cityInsurance: {
      pageNotFound: "Página No Encontrada",
      requestedNotFound: "La ciudad o tipo de seguro solicitado no fue encontrado.",
      whyChooseUs: "¿Por Qué Elegirnos para",
      uniqueNeeds: "Entendemos las necesidades únicas de los residentes de",
      residents: "y proporcionamos soluciones de seguro de vida personalizadas para familias de",
      families: ".",
      localBenefits: [
        "Licenciado en California (Licencia CA #6013543)",
        "Sin examen médico requerido para la mayoría de aplicantes",
        "Cotizaciones en línea disponibles 24/7",
        "Experiencia local en seguros de California"
      ],
      coverageFor: "Cobertura para Residentes de",
      livingIn: "Viviendo en",
      youNeed: "necesitas protección de seguro de vida que se adapte a tu estilo de vida de California. Nuestras pólizas de",
      policiesDesigned: "están diseñadas específicamente para residentes de California, con tarifas competitivas y opciones de cobertura integral.",
      longtime: "Ya seas un residente de mucho tiempo de",
      resident: "o nuevo en",
      protecting: "proteger el futuro financiero de tu familia es esencial. Nuestro proceso de aplicación en línea hace que sea fácil obtener cobertura sin la molestia de las compras tradicionales de seguros.",
      proudlyServing: "Sirviendo orgullosamente a",
      andAllOf: "y todo el",
      getYourQuote: "Obtén Tu Cotización de",
      quoteTodayBtn: "Hoy",
      applicationTime: "Tiempo de Aplicación:",
      medicalExam: "Examen Médico:",
      approvalTime: "Tiempo de Aprobación:",
      coverageArea: "Área de Cobertura:",
      minutes: "10-15 minutos",
      usuallyNotRequired: "Generalmente no requerido",
      oftenInstant: "A menudo instantáneo",
      getQuoteBtn: "Obtener Mi Cotización de",
      quote: "",
      licensedProfessionals: "Profesionales de seguros licenciados en California • Licencia CA #6013543",
      whatResidentsSay: "Lo Que Dicen los Residentes de",
      residentsSay: "",
      coverage: "Cobertura:",
      premium: "Prima:",
      readyToProtect: "¿Listo para Proteger a Tu Familia de",
      family: "?",
      dontWait: "No esperes para asegurar el futuro financiero de tu familia. Obtén tu cotización personalizada de",
      forCity: "para",
      today: "hoy.",
      getQuoteNow: "Obtener Mi Cotización de",
      quoteNow: "Ahora",
      licensedServing: "Licenciado en California • Sirviendo a",
      and: "y"
    },

    // Footer
    footer: {
      coverageAcrossCA: "Cobertura de Seguro de Vida en Toda California",
      coverageSubtitle: "Burbank Insurance Services sirve orgullosamente a residentes en toda California con soluciones integrales de seguro de vida. Encuentra opciones de cobertura en tu ciudad.",
      popularProducts: "Productos Populares de Seguro de Vida",
      availableThroughout: "Disponible en toda California",
      additionalServices: "Servicios Adicionales de Seguro de Vida", 
      availableAllCities: "Disponible en todas las ciudades de California",
      californiaLifeInsurance: "Cobertura de Seguro de Vida de California",
      footerText1: "Burbank Insurance Services se enorgullece de servir a residentes en todo el estado de California con soluciones integrales de seguro de vida. Ya sea que estés en Los Ángeles, San Francisco, San Diego, o cualquier otra ciudad de California, nuestros profesionales de seguros licenciados están aquí para ayudarte a encontrar la cobertura adecuada para las necesidades de tu familia.",
      footerText2: "Nos especializamos en seguro de vida a término, seguro de vida entera, y pólizas de seguro de vida sin examen para residentes de California. Nuestro proceso de aplicación en línea hace que sea fácil obtener cotizaciones y aplicar para cobertura desde cualquier lugar en el Estado Dorado.",
      serviceAreas: "Áreas de Servicio:",
      serviceAreasText: "Servimos todas las ciudades principales de California incluyendo el Condado de Los Ángeles, Condado de Orange, Área de la Bahía de San Francisco, Condado de San Diego, Sacramento, Fresno, Condado de Riverside, Condado de San Bernardino, y todas las áreas circundantes en toda California.",
      getCaliforniaQuote: "Obtén Tu Cotización de Seguro de Vida de California",
      licensedInCA: "Licenciado en California • Licencia CA #6013543",
      learnMore: "Aprende Más",
      contactUs: "Contáctanos", 
      servingCAOnly: "Sirviendo solo a residentes de California",
      readyToStart: "¿Listo para Comenzar?",
      getPersonalizedQuote: "Obtén tu cotización personalizada en minutos.",
      getMyPriceNow: "Obtener Mi Precio Ahora",
      allRightsReserved: "Todos los derechos reservados. Licencia CA #6013543",
      protectingFamilies: "Protegiendo familias de California con soluciones modernas de seguro de vida.",
      termVsWhole: "Término vs Vida Entera",
      onlineVsAgent: "En Línea vs Agente",
      lifeInsurance: "Seguro de Vida",
      insuranceConsultation: "Consulta de Seguros",
      cities: "ciudades"
    },

    // Common/Shared
    common: {
      getQuote: "Obtener Cotización",
      contactAgent: "Contactar Agente",
      learnMore: "Aprende Más", 
      readMore: "Leer Más",
      getStarted: "Comenzar",
      close: "Cerrar",
      next: "Siguiente", 
      previous: "Anterior",
      loading: "Cargando...",
      error: "Error",
      success: "Éxito"
    }
  }
};

export const getTranslation = (language, key) => {
  const keys = key.split('.');
  let translation = translations[language];
  
  for (const k of keys) {
    if (translation && translation[k]) {
      translation = translation[k];
    } else {
      // Fallback to English if translation not found
      translation = translations.en;
      for (const k of keys) {
        if (translation && translation[k]) {
          translation = translation[k];
        } else {
          return key; // Return key if no translation found
        }
      }
      break;
    }
  }
  
  return translation || key;
};